import { render, staticRenderFns } from "./TaskUserIdentity.vue?vue&type=template&id=11892b86"
import script from "./TaskUserIdentity.vue?vue&type=script&lang=js"
export * from "./TaskUserIdentity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports